import { FabricProvider } from '@fabric-ui/components';
import { useAvContext } from './AvContextProvider';
import { useLayoutContext } from './LayoutContext';
import { ContextProviderComponent } from './types';

export const FabricUIProvider: ContextProviderComponent = ({ children }) => {
  const avContext = useAvContext();
  const layout = useLayoutContext();

  const value = {
    avContext,
    layout,
  };
  return <FabricProvider value={value}>{children}</FabricProvider>;
};
